import { Pressable } from "react-native";
import { useUnistyles } from "react-native-unistyles";
import { View, Text } from "@src/components";
import type { Period } from "../utils/summarise-buckets";

interface PeriodDropdownProps {
  value: Period;
  onChange: (next: Period) => void;
}

const OPTIONS: { value: Period; label: string }[] = [
  { value: "1d", label: "1d" },
  { value: "3d", label: "3d" },
  { value: "7d", label: "7d" },
  { value: "30d", label: "30d" },
];

export function PeriodDropdown({ value, onChange }: PeriodDropdownProps) {
  const { theme } = useUnistyles();
  return (
    <View
      style={{
        flexDirection: "row",
        borderWidth: 1,
        borderColor: theme.colors.borderCard,
        borderRadius: theme.spacing.md,
        overflow: "hidden",
        alignSelf: "flex-start",
      }}
    >
      {OPTIONS.map((opt, index) => {
        const isSelected = value === opt.value;
        return (
          <Pressable
            key={opt.value}
            onPress={() => onChange(opt.value)}
            accessibilityRole="button"
            accessibilityState={{ selected: isSelected }}
            style={{
              paddingVertical: theme.spacing.lg,
              paddingHorizontal: theme.spacing["3xl"],
              backgroundColor: isSelected ? theme.colors.icon : "transparent",
              borderLeftWidth: index === 0 ? 0 : 1,
              borderLeftColor: theme.colors.borderCard,
            }}
          >
            <Text textStyle={isSelected ? "sm/semibold" : "sm/regular"} color={isSelected ? "background" : "text"}>
              {opt.label}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
}
